export const SET_LOADING = "setLoading";
export const SET_ERROR = "setError";
export const SET_RESET = "setReset";
export const SET_WHY = "setWhy";
export const SET_Slider = "setSlider";
export const SET_GRID = "setGrid";
export const SET_HINT = "setHint";
export const SET_TOPIC_NEWS = "setTopicNews";
export const SET_CONTACT = "setContact";
export const SET_SOCIAL = "setSocial";


